export const API_BASE_URL = "https://app-samis-1.azurewebsites.net";
